import "antd/dist/reset.css";
import "./styles/App.css";
import "./styles/footer.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Router from "./routers/Router";
import { AuthProvider } from "./contexts/AuthContext";
import AnalysisIframe from "./components/AnalysisIframe.jsx";
import MysteryClientIframe from "./components/MysteryClientIframe.jsx";


function AppContent() {
  const location = useLocation();
  const isAnalysisRoute = location.pathname === "/analysis";
  const isMysteryClientRoute = location.pathname === "/mystery-client";
  const [iframeReady, setIframeReady] = useState(false);
  const [mysteryClientIframeReady, setMysteryClientIframeReady] = useState(false);

  // Conditionally render screensaver if inactive for 30 seconds 30000

  const handleIframeLoad = useCallback(() => {
    setIframeReady(true);
  }, []);

  const handleMysteryClientIframeLoad = useCallback(() => {
    setMysteryClientIframeReady(true);
  }, []);

  return (
    <div className="app-layout">
      {/* Show screensaver after 30 seconds of inactivity */}
      <Router />
      {/* Persistent iframe: always mounted, only visible on /analysis */}
      <AnalysisIframe visible={isAnalysisRoute} onIframeLoad={handleIframeLoad} />
      <MysteryClientIframe visible={isMysteryClientRoute} onIframeLoad={handleMysteryClientIframeLoad} />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
